import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SearchIcon } from "lucide-react";
const HeroSection = () => {
  return <section className="bg-gradient-to-r from-reagent-blue to-reagent-green py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            
            
            
          </div>
          <div className="md:w-1/2 flex justify-center">
            <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Find a Reagent</h2>
              <div className="relative mb-4">
                <Input placeholder="Search by reagent name, catalog number..." className="pl-10" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              </div>
              <Button asChild className="w-full bg-reagent-blue hover:bg-blue-700">
                <Link to="/reagents">Search</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;